<template>
    <data-table
        action-button-text="اطلاعیه جدید"
        action-button-icon="add"
        show-select
        remove-key="announcement"
        export-key="employeeAnnouncement"
        settings-key="employeeAnnouncement"
        @click:actionButton="router.push({path: '/employeeAnnouncement/new' })"
        @getList="getList"
        @deleted="system.setSystemDefaults(true);"
        :rowClick="(row) => router.resolve({path: `/employeeAnnouncement/${row.id}`})"
        :headers="headers"
        :items="items"
        :loading="loading"
        :totalItems="totalItems"
        :filters="filters"
        :getAllList="getAllList"
    >
        <template #item.branches="{value}">
            <span v-if="value.length == 1">{{ value[0].name }}</span>
            <v-menu v-else>
                <template #activator="{ props }">
                    <v-btn v-bind="props" icon="icon-comment-user" color="primary" variant="text"></v-btn>
                </template>
                <div class="py-3 px-8 bg-white elevation-1">
                    <p v-for="item in value" class="text-small text-secondary font-weight-bold my-2">{{ item.name }}</p>
                </div>
            </v-menu>
        </template>
        <template #item.departments="{value}">
            <span v-if="value.length == 1">{{ value[0].name }}</span>
            <v-menu v-else>
                <template #activator="{ props }">
                    <v-btn v-bind="props" icon="icon-comment-user" color="primary" variant="text"></v-btn>
                </template>
                <div class="py-3 px-8 bg-white elevation-1">
                    <p v-for="item in value" class="text-small text-secondary font-weight-bold my-2">{{ item.name }}</p>
                </div>
            </v-menu>
        </template>
        <template #item.announcement_type="{value}">
            <v-chip :color="system.announcementTypes.find(x => x.title == value).color" variant="flat" class="text-small justify-center rounded" style="width: 68px;">{{value}}</v-chip>
        </template>
        <template #item.stared="{value, item}">
            <v-btn @click.stop="makeStar(item)" :icon="value ? 'icon-starfill' : 'icon-star'" color="primary" size="20" variant="text"></v-btn>
        </template>
    </data-table>
</template>
<script setup>
import { useApi } from '@/plugins/api';
import { useAuthStore } from '@/stores/auth';
import { useSystemStore } from '@/stores/system';
import { useRouter } from 'vue-router';

defineOptions({
    title: "اطلاعیه‌های کاربران سازمانی",
    validate(context) {
        return context.auth.user.full_admin || context.auth.user.branch_admin;
    },
})
const api = useApi();
const moment = useMoment();
const router = useRouter();
const system = useSystemStore();
const auth = useAuthStore();
const loading = ref(false);
const items = ref([]);
const totalItems = ref(0);
const headers = ref([
    {
        title: '',
        key: 'stared',
        value: (item) => item.stared,
        minWidth: 25,
        filterable: false,
        sortable: false,
        exportable: false,
        removeable: false,
    },
    {
        title: 'عنوان',
        key: 'name',
        value: (item) => item.name,
        minWidth: 230,
    },
    {
        title: 'متن',
        key: 'content',
        value: (item) => item.content.replace(/<[^>]*>?/gm, ""),
        minWidth: 380,
    },
    {
        title: 'شعبه ها',
        key: 'branches',
        exportValue: (item) => item.branches.map(x => x.name).join(', '),
        minWidth: 160,
        filterable: false,
        sortable: false,
    },
    {
        title: 'دپارتمان ها',
        key: 'departments',
        exportValue: (item) => item.departments.map(x => x.name).join(', '),
        minWidth: 160,
        filterable: false,
        sortable: false,
    },
    {
        title: 'میزان اهمیت',
        key: 'announcement_type',
        align: 'center',
        value: (item) => system.announcementTypes.find(x => x.id == item.announcement_type_id).title,
        minWidth: 100,
        maxWidth: 100
    },
    {
        title: 'تاریخ شروع',
        key: 'start_date',
        cellProps: {style: 'direction: ltr; text-align: right'},
        value: (item) => item.start_date ? moment(item.start_date).format('jYYYY/jMM/jDD | HH:mm') : undefined,
        minWidth: 150,
    },
    {
        title: 'تاریخ پایان',
        key: 'end_date',
        cellProps: {style: 'direction: ltr; text-align: right'},
        value: (item) => item.end_date ? moment(item.end_date).format('jYYYY/jMM/jDD | HH:mm') : undefined,
        minWidth: 150,
    },
    {
        title: 'وضعیت',
        key: 'status',
        value: (item) => item.status ? 'فعال' : 'غیر فعال',
        minWidth: 70,
    },
]);
const filters = ref({
    page: { type: 'hidden', label: 'صفحه', value: 1 },
    perPage: { type: 'hidden', label: 'تعداد آیتم در صفحه', value: 10 },
    keyword_based: { type: 'divider', label: 'بر اساس کلمه کلیدی', value: null },
    sname: { type: 'text', label: 'عنوان', value: null },
    scontent: { type: 'text', label: 'متن', value: null },
    display_based: { type: 'divider', label: 'بر اساس شرایط نمایش', value: null },
    branches: { type: 'autocomplete', multiple: true, label: 'شعبه', items: system.branches, value: [], permission: auth.user.full_admin },
    departments: { type: 'autocomplete', multiple: true, label: 'دپارتمان', items: system.departments, value: [] },
    importance_based: { type: 'divider', label: 'بر اساس میزان اهمیت', value: null },
    announcementTypes: { type: 'autocomplete', multiple: true, label: 'میزان اهمیت', itemTitle: 'title', items: system.announcementTypes, value: [] },
    date_based: { type: 'divider', label: 'بر اساس تاریخ', value: null },
    from_date: { type: 'date', label: 'تاریخ', group: 'start', onChange: (value) => { filters.value.to_date.value = value > filters.value.to_date.value ? null : filters.value.to_date.value; filters.value.to_date.min = value; }, value: null },
    to_date: { type: 'date', label: 'تاریخ', group: 'end', min: null, value: null },
    status_based: { type: 'divider', label: 'بر اساس وضعیت', value: null },
    status: { type: 'autocomplete', label: 'وضعیت', items: [{ name: 'فعال', id: '1' },{ name: 'غیرفعال', id: '0' }], value: null },
});
function makeStar(item) {
    api.announcementUpdate(item.id, { employee: 1, stared: !item.stared }).then((res) => {
        if (res && res.status == "UPDATED")
            item.stared = !item.stared;
    });
}
async function getList(finalFilters, cb = false) {
    loading.value = true;
    await api.announcementList({...finalFilters, employee: 1}).then(async res => {
        if (res && res.status == "OK") {
            items.value = res.data;
            totalItems.value = res.total;
        }
    }).finally(() => loading.value = false);
    if (cb)
        cb();
}
async function getAllList(finalFilters) {
    let page = 1, data = [];
    while (page) {
        await api.announcementList({
            ...finalFilters,
            employee: 1,
            perPage: 200,
            page: page,
        }).then(async res => {
            if (res && res.status == "OK") {
                data = data.concat(res.data);
                page = page == res.totalPages ? false : page + 1
            } else
                page = false;
        }).catch(() => page = false);
    }
    return data;
}
</script>
